















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { ActionMethod } from "vuex";
import SignalRHub from "@/services/SignalRHub";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import {
  ReferralEspoedDetailsModel,
  RelatedReferralModel,
  Attachment,
  Sign,
  SignValue,
  ObservationHeader,
  ExternalMonitorLinkModel,
} from "@/types/aznconnect_api";
import DetailPaneRelatedReferrals from "@/components/DetailPaneRelatedReferrals.vue";
import MessageHistoryDialog from "@/components/espoedv2/MessageHistoryDialog.vue";
import RawMessageView from "@/components/RawMessageView.vue";
import ReferralIcon from "@/components/ReferralIcon.vue";
import Timings from "@/components/espoed/Timings.vue";
import InformationCard from "@/components/InformationCard.vue";
import InformationCardValues from "@/components/InformationCardValues.vue";
import DefaultPatientSearchDialog from "@/components/espoed/DefaultPatientSearchDialog.vue";
import TrendLineChart from "@/components/TrendLineChart.vue";
import { LabeledText, SignalREvents } from "@/types/types";
import AmbulanceFeedbackDetailPane from "@/components/ambulancefeedback/DetailPane.vue";
import ProfessionalSummaryDetailPane from "@/components/professionalsummary/DetailPane.vue";
import GeneralCommentView from "@/components/espoedv2/GeneralCommentView.vue";
import BodyPositionView from "@/components/espoedv2/BodyPositionView.vue";
import PrimarySurveyV2View from "@/components/espoedv2/PrimarySurveyV2View.vue";
import SecundarySurveyV2View from "@/components/espoedv2/SecundarySurveyV2View.vue";
import MedicalConditionWorkingDiagnosisSectionView from "@/components/espoedv2/MedicalConditionWorkingDiagnosisSectionView.vue";
import ConsentSectionView from "@/components/espoedv2/ConsentSectionView.vue";
import AgreementsWithPatientView from "@/components/espoedv2/AgreementsWithPatientView.vue";
import ConsultingExternalProfessionalSectionView from "@/components/espoedv2/ConsultingExternalProfessionalSectionView.vue";
import { UserPermissions } from "@/types/store";
import { decodeVehicleNumber } from "@/services/vehicleNumberDecoder";
import TeamsCallAmbulance from "@/components/msGraph/TeamsCallAmbulance.vue";
import ArrivalTimerView from "@/components/espoedv2/ArrivalTimerView.vue";
import { PersonFormatter } from "@/services/personFormatter";
import { Configuration } from "@/services/Configuration";

@Component({
  name: "espoedv2-detail-pane",
  components: {
    "detail-pane-related-referrals": DetailPaneRelatedReferrals,
    "information-card": InformationCard,
    "information-card-values": InformationCardValues,
    "referral-icon": ReferralIcon,
    timings: Timings,
    "default-patient-search-dialog": DefaultPatientSearchDialog,
    "trendline-chart": TrendLineChart,
    "raw-message-view": RawMessageView,
    "ambulance-feedback-detail-pane": AmbulanceFeedbackDetailPane,
    "professional-summary-detail-pane": ProfessionalSummaryDetailPane,
    "general-comment-view": GeneralCommentView,
    "body-position-view": BodyPositionView,
    "primary-survey-v2-view": PrimarySurveyV2View,
    "secundary-survey-v2-view": SecundarySurveyV2View,
    "medical-condition-working-diagnosis-section-view": MedicalConditionWorkingDiagnosisSectionView,
    "consent-section-view": ConsentSectionView,
    "agreements-with-patient-view": AgreementsWithPatientView,
    "consulting-external-professional-section-view": ConsultingExternalProfessionalSectionView,
    "teams-call-ambulance": TeamsCallAmbulance,
    "arrival-timer-view": ArrivalTimerView,
    "message-history-dialog": MessageHistoryDialog,
  },
})
export default class DetailPane extends Vue {
  get configuration() {
    return Configuration;
  }
  @Prop({ default: null })
  referral!: ReferralEspoedDetailsModel;

  @Prop({ default: null })
  relatedReferrals!: RelatedReferralModel[];

  @Prop({ default: null })
  referralState!: string;

  @Prop({ default: false })
  isReadOnly!: boolean;

  @Prop({ default: false })
  allowLinkPatientNumber!: boolean;

  @Prop({ default: false })
  allowSetReferralState!: boolean;

  @Prop({ default: true })
  allowPageClose!: boolean;

  @Prop({ default: "" })
  patientNumber!: string;

  @Prop({ default: null })
  signalRHub!: SignalRHub;

  @Prop({ default: false })
  allowProfessionalSummary!: boolean;

  @Prop({ default: false })
  isHistoryView!: boolean;

  MODE_ESPOED: number = 1;
  MODE_AMBU_FEEDBACK: number = 2;
  MODE_PS: number = 3;
  MODE_EXTERNAL_MONITOR = 4;

  mode: number = this.MODE_ESPOED;

  @Getter("userPermissions")
  userPermissions!: UserPermissions;

  @Action("resolveReferral", { namespace: "espoed" })
  resolveReferralAction!: ActionMethod;

  @Watch("referral", { immediate: true }) onPropChanged(
    value: ReferralEspoedDetailsModel,
    oldValue: ReferralEspoedDetailsModel,
  ) {
    this.signTimestamps = this.sortSignTimestamps();
  }

  resolveReferral(): void {
    this.resolveReferralAction(this.referral.Reference);
  }

  isEditingPatientNumber: boolean = false;
  showImageDialog: boolean = false;
  showHistoryDialog: boolean = false;
  signTimestamps: Array<string> = [];
  attachmentPreviewText: string | null = null;
  attachmentPreviewUrl: string = "";

  developerMode: boolean = false;
  advancedMode: boolean = false;
  failedToLoad: boolean = false;

  showSignChart: boolean = false;
  signChartData: any = {};
  signChartOptions: any = {};

  externalMonitorModel: ExternalMonitorLinkModel | null = null;

  created(): void {
    if (this.signalRHub != null) {
      this.signalRHub.hubProxy.on(
        SignalREvents.UpdateEtaTime,
        this.etaTimeUpdatedHandler,
      );
    }
  }

  beforeDestroy(): void {
    if (this.signalRHub != null) {
      this.signalRHub.hubProxy.off(
        SignalREvents.UpdateEtaTime,
        this.etaTimeUpdatedHandler,
      );
    }
  }

  mounted() {
    var me = this;
    if (me.referral.HasExternalMonitorApi && !me.isHistoryView) {
      AZNCONNECT_API.get(
        "/ExternalMonitor/Get?referenceId=" + me.referral.Reference,
        {},
      ).then(response => {
        me.externalMonitorModel = response.data as ExternalMonitorLinkModel;
      });
    }
  }

  get patientInformationValues(): Array<LabeledText> {
    const formatDate = Vue.filter("formatDate");
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    let birthDate = "";
    if (referralModel.PatientBirthDate) {
      birthDate = formatDate(referralModel.PatientBirthDate);
      if (referralModel.PatientAge != null) {
        birthDate = birthDate + " (" + referralModel.PatientAge + " jaar)";
      }
    }
    values.push(new LabeledText("Geboortedatum", birthDate));
    values.push(new LabeledText("BSN", referralModel.PatientBSN));

    if (referralModel.PassportNumber !== null) {
      values.push(
        new LabeledText("Paspoortnummer", referralModel.PassportNumber),
      );
    }
    if (referralModel.DriversLicenseNumber !== null) {
      values.push(
        new LabeledText("Rijbewijsnummer", referralModel.DriversLicenseNumber),
      );
    }

    if (referralModel.IDCardNumber !== null) {
      values.push(
        new LabeledText("Identiteitskaartnummer", referralModel.IDCardNumber),
      );
    }

    if (referralModel.AliensDocumentNumber !== null) {
      values.push(
        new LabeledText(
          "Vreemdelingen-documentnummer",
          referralModel.AliensDocumentNumber,
        ),
      );
    }

    values.push(
      new LabeledText(
        "Adres",
        `${referralModel.PatientAddressLine1}, ${
          referralModel.PatientAddressLine2
        }`,
      ),
    );

    values.push(new LabeledText("Telefoon", referralModel.PatientPhoneNumber));
    values.push(new LabeledText("E-mail", referralModel.PatientMailAddress));
    values.push(
      new LabeledText(
        "Verzekerd?",
        referralModel.InsuranceValid == true ? "Ja" : "Nee",
      ),
    );

    const practitioner = PersonFormatter.formatPractitioner(
      referralModel.GeneralPractitionerName,
      referralModel.GeneralPractitionerAgbCode,
    );
    values.push(new LabeledText("Huisarts", practitioner));
    values.push(
      new LabeledText(
        "Praktijk ",
        referralModel.ScopingOrganizationName || "Onbekend",
      ),
    );

    values.push(
      new LabeledText(
        "Praktijk adres",
        referralModel.ScopingOrganizationAddress || "Onbekend",
      ),
    );

    values.push(
      new LabeledText(
        "Praktijk telefoon",
        referralModel.ScopingOrganizationTel || "Onbekend",
      ),
    );

    values.push(
      new LabeledText("Contactpersoon", referralModel.ContactName || "-"),
    );

    values.push(
      new LabeledText(
        "Relatie",
        referralModel.ContactRoleTypeDisplayName || "-",
      ),
    );

    values.push(
      new LabeledText(
        "Contactpersoon tel.",
        referralModel.ContactPhoneNumber || "-",
      ),
    );

    return values;
  }

  get rideInformationValues(): Array<LabeledText> {
    const formatDate = Vue.filter("formatDate");
    const formatDateTime = Vue.filter("formatDateTime");
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    if (referralModel.DepartureTime) {
      values.push(
        new LabeledText(
          "Datum",
          formatDate(referralModel.DepartureTime.DateTime),
        ),
      );
    }
    values.push(
      new LabeledText("Vertrek locatie", referralModel.DepartureLocation || ""),
    );
    values.push(
      new LabeledText("Organisatie", referralModel.SendingEntity || ""),
    );
    values.push(new LabeledText("Ritnummer", referralModel.Reference || ""));

    const ambulanceId = referralModel.AmbulanceId || "";
    let label = "Ambulance";

    if (ambulanceId) {
      const { vehicle, specialCase } = decodeVehicleNumber(ambulanceId);
      if (vehicle === "MMT" && specialCase === "Helikopter") {
        label = "Helicopter";
      }
    }

    values.push(new LabeledText(label, ambulanceId));

    values.push(
      new LabeledText("Wzd/Wvggz", referralModel.WzdWvggzMeasure || ""),
    );
    values.push(
      new LabeledText(
        "Aanvang TVZ",
        formatDateTime(referralModel.StartTimeInvoluntaryCare) || "",
      ),
    );

    values.push(
      new LabeledText(
        "Zorgaanvrager",
        referralModel.CareRequesterType || "Onbekend",
      ),
    );

    return values;
  }

  get anamneseValues(): Array<LabeledText> {
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    if (referralModel && referralModel.SecondarySurveys) {
      for (const secondarySurvey of referralModel.SecondarySurveys) {
        values.push(
          new LabeledText(secondarySurvey.Name, secondarySurvey.Value),
        );
      }
    }

    return values;
  }

  get mechanismValues(): Array<LabeledText> {
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    if (
      referralModel &&
      referralModel.MechanismObservations &&
      referralModel.MechanismObservations.length > 0
    ) {
      for (const mechanismObservation of referralModel.MechanismObservations) {
        values.push(
          new LabeledText(
            mechanismObservation.Code,
            mechanismObservation.Value,
          ),
        );
      }
    } else if (
      referralModel &&
      referralModel.Mechanisms &&
      referralModel.Mechanisms.length == 0
    ) {
      values.push(new LabeledText("Geen", ""));
    }
    return values;
  }

  get faAmbulanceIdIcon(): string {
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    const ambulanceId = referralModel.AmbulanceId;
    if (!ambulanceId) return "";

    const { vehicle, specialCase } = decodeVehicleNumber(ambulanceId);
    const isHelicopter = vehicle === "MMT" && specialCase === "Helikopter";

    return isHelicopter ? "fa fa-helicopter" : "fa fa-ambulance";
  }

  injuryValues(injuryObservationHeader: ObservationHeader): Array<LabeledText> {
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;
    if (injuryObservationHeader.ObservationModels != null) {
      for (const injuryObservation of injuryObservationHeader.ObservationModels) {
        values.push(
          new LabeledText(
            `${injuryObservation.Code}`,
            `${injuryObservation.Value}`,
          ),
        );
      }
    }

    return values;
  }

  sortSignTimestamps(): Array<string> {
    let signTimestamps = [];
    if (this.referral && this.referral.Signs) {
      for (const sign of this.referral.Signs) {
        for (const signValue of sign.Values) {
          if (signTimestamps.find(t => t == signValue.Timestring) == null) {
            signTimestamps.push(signValue.Timestring);
          }
        }
      }
    }
    return signTimestamps.sort();
  }

  get filters(): any {
    return this.$options.filters || {};
  }

  signOnClickHandler(sign: Sign): void {
    let vm = this;
    var signChartDataValues: Array<number> = [];
    var calculatedMaxY: number = 0;

    var ascendingTimestamps = this.signTimestamps.sort();

    ascendingTimestamps.forEach(signTimestamp => {
      var stringValue = vm.getSignValue(sign, signTimestamp);
      var numberValue = Number.parseInt(stringValue);

      if (numberValue && numberValue > calculatedMaxY) {
        calculatedMaxY = numberValue * 1.2;
      }

      signChartDataValues.push(numberValue);
    });

    var timestamps = ascendingTimestamps.map(x => this.filters.formatTime(x));

    this.signChartData = {
      labels: timestamps,
      datasets: [
        {
          label: sign.Name,
          fill: false,
          lineTension: 0.2,
          backgroundColor: "#181E3C",
          borderColor: "#181E3C",
          data: signChartDataValues,
        },
      ],
    };

    this.signChartOptions = {
      legend: {
        display: true,
        position: "top",
        labels: {
          fontFamily: "Roboto, sans-serif",
          boxWidth: 16,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              suggestedMin: 0,
              suggestedMax: calculatedMaxY,
            },
          },
        ],
      },
      title: {
        display: false,
        text: sign.Name,
      },
    };

    this.showSignChart = true;
  }

  copyLinkToClipboard(): void {
    const route = this.$router.resolve({
      name: "referral-details",
      params: { referralId: this.referral.Reference || "" },
    });
    const url = window.location.origin + "/" + route.href;

    var temp = $("<input>");
    $("body").append(temp);
    temp.val(url).select();
    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
    temp.remove();
  }

  toggleDeveloperMode(): void {
    var me = this;
    me.developerMode = !me.developerMode;
  }

  downloadReferral(): void {
    var me = this;

    let model = {
      Action: "DownloadReferralPdf",
      Parameters: { id: me.referral.Reference },
      FileType: "pdf",
    };

    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, model)
      .then(response => {
        window.location.href = response.data;
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  toggleAdvancedMode(): void {
    var me = this;
    me.advancedMode = !me.advancedMode;
  }

  getSignValue(sign: Sign, timestamp: string): string {
    const signValue: SignValue | undefined = sign.Values.find(
      value => value.Timestring == timestamp,
    );
    return signValue ? signValue.Value : "";
  }

  getSignUnit(sign: Sign) {
    var displayValue = "";
    if (sign != null) {
      displayValue += sign.Value;
      if (sign.Unit) {
        displayValue += " " + sign.Unit;
      }
      if (sign.DenominatorUnit) {
        displayValue += " / ";
        if (sign.DenominatorValue && sign.DenominatorValue !== "1") {
          displayValue += sign.DenominatorValue;
        }
        displayValue += sign.DenominatorUnit;
      }
    }
    return displayValue;
  }

  previewAttachment(attachment: Attachment): void {
    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, attachment.Open)
      .then(response => {
        // Create temporary link to preserve filename
        this.attachmentPreviewText = attachment.Text;
        this.attachmentPreviewUrl = response.data;
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  closeAttachmentPreview(): void {
    // Revoke URL to free memory
    this.attachmentPreviewText = null;
    this.attachmentPreviewUrl = "";
  }

  isImage(attachment: Attachment): boolean {
    // Extract extension from filename
    const filename = attachment.Text || "";
    const lastDotIndex = filename.lastIndexOf(".");
    let extension = "";

    if (lastDotIndex > 0 && lastDotIndex < filename.length - 1) {
      extension = filename.substring(lastDotIndex + 1).toLowerCase();
    } else if (attachment.Open.FileType) {
      extension = attachment.Open.FileType.toLowerCase();
    }

    return (
      extension === "jpg" ||
      extension === "jpeg" ||
      extension === "png" ||
      extension === "gif" ||
      extension === "bmp" ||
      extension === "webp"
    );
  }

  getMimeTypeFromExtension(fileType: string | null): string {
    if (!fileType) return "application/octet-stream";

    const ext = fileType.toLowerCase();
    const mimeTypes: { [key: string]: string } = {
      // Images
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      bmp: "image/bmp",
      webp: "image/webp",
      svg: "image/svg+xml",
      // Documents
      pdf: "application/pdf",
      doc: "application/msword",
      docx:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ppt: "application/vnd.ms-powerpoint",
      pptx:
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      txt: "text/plain",
      csv: "text/csv",
      xml: "application/xml",
      json: "application/json",
      // Archives
      zip: "application/zip",
      rar: "application/x-rar-compressed",
      "7z": "application/x-7z-compressed",
    };

    return mimeTypes[ext] || "application/octet-stream";
  }

  openAttachment(attachment: Attachment): void {
    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, attachment.Open)
      .then(response => {
        // Create temporary link to preserve filename
        const link = document.createElement("a");
        link.href = response.data;
        link.target = "_blank";
        link.download = attachment.Text;

        //For PDFs and images, remove download attribute to view in browser
        if (
          attachment.Open.FileType === "pdf" ||
          attachment.Open.FileType === "image"
        ) {
          link.removeAttribute("download");
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  downloadAttachment(attachment: Attachment): void {
    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, attachment.Download)
      .then(response => {
        window.location.href = response.data;
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  etaTimeUpdatedHandler(referenceId: string, etaDate: string, etaTime: string) {
    console.log(
      `Received ETA update for referenceId=${referenceId}: etaDate=${etaDate}, etaTime=${etaTime}`,
    );
    if (this.referral && this.referral.Reference === referenceId) {
      this.referral.EtaDate = etaDate;
      this.referral.EtaTime = etaTime;
    }
  }

  closeDetails(): void {
    this.$emit("close");
  }

  destroyed() {
    // Clean up preview URL
    this.attachmentPreviewText = null;
    this.attachmentPreviewUrl = "";
    this.$emit("closed");
  }
}
